import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./expandableSection.html";
class ExpandableSection extends LightningElement {
  constructor(...args) {
    super(...args);
    this.toggleTextExpanded = void 0;
    this.readMoreLink = void 0;
    this.readMoreLinkText = void 0;
    this.toggleText = void 0;
    this.defaultCollapsed = 'false';
    this.baseContainerClass = 'axwp-expandable-section__container';
  }
  get expanded() {
    return this._expanded;
  }
  set expanded(expand) {
    this._expanded = expand;
  }
  get toggleButtonText() {
    return this.expanded ? this.toggleTextExpanded : this.toggleText;
  }
  get toggleIcon() {
    return this.expanded ? 'chevronup' : 'chevrondown';
  }
  get containerClass() {
    let className = this.baseContainerClass;
    if (this.expanded) {
      className += ' is-expanded';
    }
    return className;
  }
  get hasReadMoreLink() {
    return this.readMoreLink && this.readMoreLinkText;
  }
  get contentHeight() {
    return Number(this.content?.scrollHeight);
  }

  /**
   * On component mount.
   * Set the max height of the component content area.
   *
   * @returns {void}
   */
  connectedCallback() {
    requestAnimationFrame(() => {
      this.initComponent();
    });
  }

  /**
   * On component mount.
   * Query for DOM elements and attach event listeners.
   *
   * @returns {void}
   */
  renderedCallback() {
    this.container = this.template?.querySelector(`.${this.baseContainerClass}`);
    this.content = this.template?.querySelector('.axwp-expandable-section__content');
    this.moreBtn = this.template?.querySelector('.axwp-expandable-section__more-button');
    this.expandBar = this.template?.querySelector('.axwp-expandable-section__toggle ax-bar');
    this.expandBtn = this.expandBar?.shadowRoot?.querySelector('button');
  }

  /**
   * On component unmount.
   * Remove event listeners.
   *
   * @returns {void}
   */
  disconnectedCallback() {
    this.expandBtn?.removeEventListener('click', this.handleExpand.bind(this));
  }

  /**
   * Initialize the component.
   * Set the default expanded state and content height.
   */
  initComponent() {
    this._expanded = this.defaultCollapsed !== 'false';
    this.setContentHeight();
    this.handleExpand();
    this.expandBtn?.addEventListener('click', this.handleExpand.bind(this));
  }

  /**
   * Toggle the Expandable Section.
   *
   * @returns {void}
   */
  handleExpand() {
    this._expanded = !this.expanded;
    this.updateExpandButton();
    if (this.container) {
      this.container.setAttribute('class', this.containerClass);
    }
  }

  /**
   * Update the Text and Icon of the Expand Button.
   *
   * @returns {void}
   */
  updateExpandButton() {
    this.expandBtn?.childNodes.forEach(node => {
      // Update the text
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.trim() !== '') {
        node.nodeValue = this.toggleButtonText;
      }

      // Rotate the icon.
      const iconNode = node;
      if (iconNode.tagName === 'AX-ICON') {
        iconNode.setAttribute('style', `transform: rotate(${!this.expanded ? 0 : 180}deg)`);
      }
    });
  }

  /**
   * Set the max height of the component content area.
   *
   * @returns {void}
   */
  setContentHeight() {
    this.content?.style.setProperty('--element-height', `${this.contentHeight}px`);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ExpandableSection, {
  publicProps: {
    toggleTextExpanded: {
      config: 0
    },
    readMoreLink: {
      config: 0
    },
    readMoreLinkText: {
      config: 0
    },
    toggleText: {
      config: 0
    },
    defaultCollapsed: {
      config: 0
    },
    expanded: {
      config: 3
    }
  },
  publicMethods: ["initComponent", "handleExpand"],
  fields: ["baseContainerClass"]
});
const __lwc_component_class_internal = _registerComponent(ExpandableSection, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;